export default __webpack_public_path__ + "assets/a753436effa50f354cdf2f4dadc673f7.svg";